import { Suspense } from 'react';
import { useLoaderData, defer, Await } from 'react-router-dom';

import Files from '../components/Files.jsx';
import { UploadFile, UploadComplete } from '../components/UploadFile.jsx';
import { getAuthToken } from '../util/auth.jsx'
import backend from '../util/backend.jsx';

function FilesPage() {
  const { files } = useLoaderData();

  return (
    <Suspense fallback={<p style={{ textAlign: 'center' }}>Loading...</p>}>
      <Await resolve={files}>
        {(loadedFiles) => <Files files={loadedFiles} />}
      </Await>
      <UploadFile />
    </Suspense>
  );
}

export default FilesPage;

function sleep(ms) {
    return new Promise(resolve => setTimeout(resolve, ms));
}

export async function action({ request }) {
  while (!UploadComplete) {
    await sleep(1000);
  };
  if ('errors' in UploadComplete) {
    return UploadComplete;
  }
  return 'ok'
}

async function loadFiles() {
  const token = getAuthToken();
  const response = await fetch(`https://${backend}/files`, {
    method: 'GET',
    headers: {
      'Content-Type': 'application/json',
      'Authorization': `Bearer ${token}`
    }
  });

  if (!response.ok) {
    return {'errors': ['Could not fetch files.']};
  } else {
    const resData = await response.json();
    return resData;
  }
}

export function loader() {
  return defer({
    files: loadFiles(),
  });
}
